

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import allReducers from './reducers';
import appSaga from './sagas/sagas';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';


const rootReducer = combineReducers(allReducers);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'question', 'receipt', 'package', 'record', 'testReport', 'examination']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(appSaga);

export const persistor = persistStore(store);
export default store;
